module.exports = __webpack_public_path__ + "img/card_icon_seven.8c43f8a8.png";